// gameUtils.js
// Import provider icons
import splitIcon from "../images/split.svg";
import spribeIcon from "../images/spribe.svg";
import elbetIcon from "../images/elbet.svg";
import pragmeticIcon from "../images/pragmetic.svg";
import imoonIcon from "../images/imoon.svg";
import faziIcon from "../images/fazi-svg.svg";
import aviatorIcon from "../images/aviator-svg.svg";
import oaksIcon from "../images/3oaks-svg.svg";
import pushgamingIcon from "../images/pushgaming-svg.svg";
import playsonIcon from "../images/playson-svg.svg";
import playngoIcon from "../images/playngo-svg.svg";
import redtigerIcon from "../images/redtiger-svg.svg";
import amaticIcon from "../images/amatic-svg.svg";
import greentubeIcon from "../images/greentube-svg.svg";
import igrosoftIcon from "../images/igrasoft-svg.svg";
import hacksawIcon from "../images/hacksaw-svg.svg";
import spinomenalIcon from "../images/spinomenal-svg.svg";
import netentIcon from "../images/netent-svg.svg";
import tadaIcon from "../images/tada-svg.svg";
import leprecoinsIcon from "../images/leprecoins-icons.svg";
import abxIcon from "../images/abx-icon.svg";
import veligamesIcon from "../images/veligames-icon.svg";
import goldenIcon from "../images/golden.svg";
import aviatrixIcon from "../images/aviatrix.svg";
import evolutionIcon from "../images/evolution.svg";
import smartsoftIcon from "../images/smartsoft.svg";
import sagamingIcon from "../images/sagaming-icon.svg";
import aviatorImg from "../images/aviator/aviator.png";
import aviatrixImg from "../images/aviatrix/aviatrix.jpeg";
import jetXimg from "../images/smartsoft/JetX.png";
import kayaIcon from "../images/kaya.svg";
import expanseIcon from "../images/expanse/expanse.png";
import spinmaticIcon from "../images/spinmatic.svg";
import { APP_CONFIG, config, GameModes } from "../config";
import { API_URL, PROVIDERS_WITHOUT_DEMO } from "../constants";

const rocketmenImg =
  "https://cdn.effective-solution.com/CasinoMobule/redtiger/156-156/rocketmen.png";
const minesImg =
  "https://cdn.effective-solution.com/CasinoMobule/spribe/156-156/mines.png";
const diceImg =
  "https://cdn.effective-solution.com/CasinoMobule/spribe/156-156/dice.png";
const kenoImg =
  "https://cdn.effective-solution.com/CasinoMobule/spribe/156-156/keno.png";

// Provider configuration with icons and display names
export const PROVIDERS = {
  fazi: {
    id: "fazi",
    name: "Fazi",
    icon: faziIcon,
    folderName: "fazi",
  },
  aviatrix: {
    id: "aviatrix",
    name: "Aviatrix",
    icon: aviatrixIcon,
    folderName: "aviatrix",
  },
  tada: {
    id: "tada",
    name: "Tada",
    icon: tadaIcon,
    folderName: "tada",
  },
  aviator: {
    id: "aviator",
    name: "Aviator",
    icon: aviatorIcon,
    folderName: "aviator",
  },

  pragmaticplay: {
    id: "pragmaticplay",
    name: "Pragmatic Play",
    icon: pragmeticIcon,
    folderName: "pragmaticplay",
  },

  abx: {
    id: "abx",
    name: "ABX",
    icon: abxIcon,
    folderName: "abx",
  },
  expanse: {
    id: "expanse",
    name: "Expanse",
    icon: expanseIcon,
    folderName: "expanse",
  },
  leprecoins: {
    id: "leprecoins",
    name: "Leprecoins",
    icon: leprecoinsIcon,
    folderName: "leprecoins",
  },
  smartsoft: {
    id: "smartsoft",
    name: "smartsoft",
    icon: smartsoftIcon,
    folderName: "smartsoft",
  },
  sagaming: {
    id: "sagaming",
    name: "SAgaming",
    icon: sagamingIcon,
    folderName: "sagaming",
  },
  veligames: {
    id: "veligames",
    name: "Veligames",
    icon: veligamesIcon,
    folderName: "veligames",
  },
  velitest: {
    id: "velitest",
    name: "Velitest",
    icon: veligamesIcon,
    folderName: "velitest",
  },
  netent: {
    id: "netent",
    name: "Netent",
    icon: netentIcon,
    folderName: "netent", // folder name in games directory
  },
  //   split: {
  //     id: "split",
  //     name: "Split The Pot",
  //     icon: splitIcon,
  //     folderName: "split", // folder name in games directory
  //   },
  spribe: {
    id: "spribe",
    name: "Spribe",
    icon: spribeIcon,
    folderName: "spribe",
  },
  relax: {
    id: "relax",
    name: "Relax",
    icon: elbetIcon,
    folderName: "relax",
  },
  // NOTE: KELT PRAGMATIC DISABLED
  // pragmatic: {
  //   id: "pragmatic",
  //   name: "Pragmatic Play",
  //   icon: pragmeticIcon,
  //   folderName: "pragmatic",
  // },
  spinomenal: {
    id: "spinomenal",
    name: "Spinomenal",
    icon: spinomenalIcon,
    folderName: "spinomenal",
  },
  redtiger: {
    id: "redtiger",
    name: "Redtiger",
    icon: redtigerIcon,
    folderName: "redtiger",
  },
  //   aviatrix: {
  //     id: "aviatrix",
  //     name: "Aviatrix",
  //     icon: aviatrixIcon,
  //     folderName: "aviatrix",
  //   },
  playngo: {
    id: "playngo",
    name: "Playngo",
    icon: playngoIcon,
    folderName: "playngo",
  },
  playson: {
    id: "playson",
    name: "Playson",
    icon: playsonIcon,
    folderName: "playson",
  },
  pushgaming: {
    id: "pushgaming",
    name: "Pushgaming",
    icon: pushgamingIcon,
    folderName: "pushgaming",
  },
  "3oaks": {
    id: "3oaks",
    name: "3oaks",
    icon: oaksIcon,
    folderName: "3oaks",
  },
  amatic: {
    id: "amatic",
    name: "Amatic",
    icon: amaticIcon,
    folderName: "amatic",
  },
  greentube: {
    id: "greentube",
    name: "Greentube",
    icon: greentubeIcon,
    folderName: "greentube",
  },
  hacksaw: {
    id: "hacksaw",
    name: "Hacksaw",
    icon: hacksawIcon,
    folderName: "hacksaw",
  },
  igrosoft: {
    id: "igrosoft",
    name: "Igrosoft",
    icon: igrosoftIcon,
    folderName: "igrosoft",
  },
};

export const KELT_PROVIDERS = {
  netent: {
    id: "netent",
    name: "Netent",
    icon: netentIcon,
    folderName: "netent", // folder name in games directory
  },
  //   split: {
  //     id: "split",
  //     name: "Split The Pot",
  //     icon: splitIcon,
  //     folderName: "split", // folder name in games directory
  //   },
  spribe: {
    id: "spribe",
    name: "Spribe",
    icon: spribeIcon,
    folderName: "spribe",
  },
  relax: {
    id: "relax",
    name: "Relax",
    icon: elbetIcon,
    folderName: "relax",
  },
  // NOTE: KELT PRAGMATIC DISABLED
  // pragmatic: {
  //   id: "pragmatic",
  //   name: "Pragmatic Play",
  //   icon: pragmeticIcon,
  //   folderName: "pragmatic",
  // },
  spinomenal: {
    id: "spinomenal",
    name: "Spinomenal",
    icon: spinomenalIcon,
    folderName: "spinomenal",
  },
  redtiger: {
    id: "redtiger",
    name: "Redtiger",
    icon: redtigerIcon,
    folderName: "redtiger",
  },
  //   aviatrix: {
  //     id: "aviatrix",
  //     name: "Aviatrix",
  //     icon: aviatrixIcon,
  //     folderName: "aviatrix",
  //   },
  playngo: {
    id: "playngo",
    name: "Playngo",
    icon: playngoIcon,
    folderName: "playngo",
  },
  playson: {
    id: "playson",
    name: "Playson",
    icon: playsonIcon,
    folderName: "playson",
  },
  pushgaming: {
    id: "pushgaming",
    name: "Pushgaming",
    icon: pushgamingIcon,
    folderName: "pushgaming",
  },
  "3oaks": {
    id: "3oaks",
    name: "3oaks",
    icon: oaksIcon,
    folderName: "3oaks",
  },
  amatic: {
    id: "amatic",
    name: "Amatic",
    icon: amaticIcon,
    folderName: "amatic",
  },
  greentube: {
    id: "greentube",
    name: "Greentube",
    icon: greentubeIcon,
    folderName: "greentube",
  },
  hacksaw: {
    id: "hacksaw",
    name: "Hacksaw",
    icon: hacksawIcon,
    folderName: "hacksaw",
  },
  igrosoft: {
    id: "igrosoft",
    name: "Igrosoft",
    icon: igrosoftIcon,
    folderName: "igrosoft",
  },
};

const isKeltProvider = (provider) => {
  return provider === "kelt" || Object.keys(KELT_PROVIDERS).includes(provider);
};
export const setSelectedProviderHandler = (providerName) => {
  if (PROVIDERS.hasOwnProperty(providerName)) {
    return PROVIDERS[providerName];
  } else {
    console.warn(`Provider "${providerName}" not found.`);
    return null;
  }
};
/**
 * Imports game images specifically for Expanse Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importExpanseGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchExpanseGames();
    // Check if the API response is valid
    if (!apiResponse?.list || !Array.isArray(apiResponse.list)) {
      throw new Error("Invalid API response format for Expanse games");
    }

    // Create an array of game objects
    const gameImages = [];

    // Using webpack's require.context to get all images in the expanse folder
    const context = require.context(
      "../images/expanse/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );

    // Get all image paths from the expanse folder
    const imagePaths = context.keys();

    apiResponse.list.forEach((game) => {
      if (game.code) {
        // Use game code as the alias
        const alias = game.code;

        // Find the matching image path for this game code
        const imagePath = imagePaths.find(
          (path) => path.includes(`/${alias}.`) // Match the game code in filename
        );

        if (imagePath) {
          gameImages.push({
            alias: alias,
            imagePath: context(imagePath),
            provider: "expanse",
            name: game.name,
            gameType: game.type,
            freeSpinBonus: game.free_spin_bonus,
            jackpot: game.jackpot,
            globalJackpot: game.global_jackpot,
            lineCoeff: game.line_coeff,
            availableLanguages: game.available_langs,
            restrictedCountries: game.restricted_countries,
          });
        }
      }
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing Expanse game images:`, error);
    return [];
  }
};
export const importVeliTest = async (dimension = "225-140") => {
  return [
    {
      alias: "e2e",
      imagePath: "https://logodix.com/logo/1716600.gif",
      provider: "velitest",
      name: "Acceptance test",
    },
  ];
};
/**
 * Imports game images specifically for Smartsoft Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importSmartsoftGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchSmartsoftGames();
    // Check if the API response is valid
    if (!apiResponse || !Array.isArray(apiResponse)) {
      throw new Error("Invalid API response format for Expanse games");
    }

    // Create an array of game objects
    const gameImages = [];

    // Using webpack's require.context to get all images in the expanse folder
    const context = require.context(
      "../images/smartsoft/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );
    // Get all image paths from the expanse folder
    const imagePaths = context.keys();

    apiResponse.forEach((game) => {
      if (game.gameName) {
        // Use game name as the alias
        const alias = game.gameName;

        // Find the matching image path for this game code
        const imagePath = imagePaths.find((path) =>
          path.includes(`/${alias}.`)
        );

        if (imagePath) {
          gameImages.push({
            alias: alias,
            imagePath: context(imagePath),
            provider: "smartsoft",
            name: game.gameName,
            gameCategory: game.gameCategory,
            hasDemo: game.hasDemo,
            gameId: game.gameId,
            gameProvider: game.provider,
            uuid: game.uuid,
            productType: game.productType,
            similarGameCategory: game.similarGameCategory,
            hasFreeSpin: game.hasFreeSpin,
          });
        }
      }
    });
    return gameImages;
  } catch (error) {
    console.error(`Error importing Expanse game images:`, error);
    return [];
  }
};
/**
 * Imports game images specifically for Smartsoft Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importVeligamesGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchVeliGames("veliplay");
    // Check if the API response is valid
    if (!apiResponse.data || !Array.isArray(apiResponse.data.items)) {
      throw new Error("Invalid API response format for Expanse games");
    }

    // Create an array of game objects
    const gameImages = [];

    // Using webpack's require.context to get all images in the expanse folder
    const context = require.context(
      "../images/veligames/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );
    // Get all image paths from the expanse folder
    const imagePaths = context.keys();

    apiResponse.data.items.forEach((game) => {
      if (game.gameId) {
        // Use game name as the alias
        const alias = game.gameId;

        // Find the matching image path for this game code
        const imagePath = imagePaths.find((path) =>
          path.includes(`/${alias}.`)
        );
        if (imagePath) {
          gameImages.push({
            alias: alias,
            imagePath: context(imagePath),
            provider: "veligames",
            name: game.name,
            gameCategory: game.category,
            hasDemo: game.hasDemoMode,
            gameId: game.gameId,
            gameProvider: game.providerId,
            deviceType: game.deviceType,
            volatility: game.volatility,
            rtp: game.rtp,
            hasFreeBets: game.hasFreeBets,
          });
        }
      }
    });
    return gameImages;
  } catch (error) {
    console.error(`Error importing Expanse game images:`, error);
    return [];
  }
};

/**
 * Imports game images specifically for Tada Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importTadaGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchTadaGames();
    // Check if the API response is valid
    if (!apiResponse?.Data || !Array.isArray(apiResponse.Data)) {
      throw new Error("Invalid API response format for Tada games");
    }

    // Create an array of game objects
    const gameImages = [];

    // Using webpack's require.context to get all images in the tada folder
    const context = require.context(
      "../images/tada/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );

    // Get all image paths from the tada folder
    const imagePaths = context.keys();

    apiResponse.Data.forEach((game) => {
      if (game.GameId) {
        // Use game code as the alias
        const alias = game.GameId;
        const gameName = game.name["en-US"];

        // Find the matching image path for this game code
        const imagePath = imagePaths.find(
          (path) => path.includes(`/${alias}.`) // Match the game code in filename
        );

        if (imagePath) {
          gameImages.push({
            alias: alias,
            imagePath: context(imagePath),
            provider: "tada",
            name: gameName,
            gameCategoryId: game.GameCategoryId,
            lobbyGameType: game.lobbyGameType,
            jackpot: game.JP,
            freeSpin: game.freeSpin,
          });
        }
      }
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing Tada game images:`, error);
    return [];
  }
};

/**
 * Imports game images specifically for Pragmatic Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importPragmaticGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchPragmaticGames();
    // Check if the API response is valid
    if (
      apiResponse?.error !== "0" ||
      !apiResponse?.gameList ||
      !Array.isArray(apiResponse.gameList)
    ) {
      throw new Error("Invalid API response format");
    }

    // Create an array of game objects
    const gameImages = [];

    apiResponse.gameList.forEach((game) => {
      if (game.gameID && game.gameName && game.gameUrl) {
        gameImages.push({
          alias: game.gameID,
          imagePath: game.gameUrl, // Use the direct URL from the API
          provider: "pragmaticplay",
          name: game.gameName,
          gameID: game.gameID,
        });
      }
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing Pragmatic game images:`, error);
    return [];
  }
};

/**
 * Imports game images specifically for Leprecoins Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importLeprecoinsGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchLeprecoinsGames();
    // Check if the API response is valid
    if (!apiResponse || !Array.isArray(apiResponse)) {
      throw new Error("Invalid API response format");
    }

    // Create an array of game objects
    const gameImages = [];

    apiResponse.forEach((game) => {
      if (game.codeName && game.name && game.iconUrl) {
        gameImages.push({
          alias: game.codeName,
          imagePath: game.iconUrl, // Use the direct URL from the API
          provider: "leprecoins",
          name: game.name,
        });
      }
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing leprecoins game images:`, error);
    return [];
  }
};

/**
 * Imports game images specifically for ABX Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importAbxGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchAbxGames();
    // Check if the API response is valid
    if (!apiResponse || !Array.isArray(apiResponse)) {
      throw new Error("Invalid API response format");
    }

    // Create an array of game objects
    const gameImages = [];

    apiResponse.forEach((game) => {
      if (game.source && game.loader && game.preview) {
        gameImages.push({
          alias: game.source,
          imagePath: game.preview,
          provider: "abx",
          name: game.loader,
          gameID: game.source,
        });
      }
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing abx game images:`, error);
    return [];
  }
};

/**
 * Imports game images specifically for Live Pragmatic Provider from API response
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importLivePragmaticGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchLivePragmaticGames();
    // Check if the API response is valid
    if (!apiResponse || !Array.isArray(apiResponse)) {
      throw new Error("Invalid API response format");
    }

    // Create an array of game objects
    const gameImages = [];

    apiResponse.forEach((game) => {
      if (game.tableId && game.tableName && game.tableImage) {
        gameImages.push({
          alias: game.tableId,
          imagePath: game.tableImage,
          provider: "pragmaticlive",
          name: game.tableName,
          gameID: game.gameID,
          maxBet: game.maxBet,
          minBet: game.minBet,
          lastResults: game.lastResults,
          totalSeatedPlayers: game.totalSeatedPlayers,
        });
      }
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing Live Pragmatic game images:`, error);
    return [];
  }
};
/**
 * Imports game images for Kelt provider using API data with local image fallback
 * @param {string} dimension - Dimension folder name (e.g., '225-140')
 * @param {string} subProvider - Optional sub-provider filter (e.g., 'igrosoft')
 * @param {Object} filters - Optional filters object
 * @param {boolean} filters.enabledOnly - Only return enabled games
 * @param {boolean} filters.desktopEnabled - Only return desktop-enabled games
 * @param {boolean} filters.mobileEnabled - Only return mobile-enabled games
 * @param {string} filters.groupAlias - Filter by group alias (e.g., 'slots')
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importKeltGameImages = async (
  dimension = "167-117",
  subProvider = null,
  filters = {}
) => {
  try {
    // Fetch games from API
    const apiResponse = await fetchKeltGames(subProvider);

    if (!apiResponse || !apiResponse.data) {
      console.warn("No Kelt games data received from API");
      return [];
    }

    let games = apiResponse.data;

    // Apply filters
    if (filters.enabledOnly !== undefined && filters.enabledOnly) {
      games = games.filter((game) => game.is_enabled === true);
    }

    if (filters.desktopEnabled !== undefined && filters.desktopEnabled) {
      games = games.filter((game) => game.desktop_enabled === true);
    }

    if (filters.mobileEnabled !== undefined && filters.mobileEnabled) {
      games = games.filter((game) => game.mobile_enabled === true);
    }

    if (filters.groupAlias) {
      games = games.filter((game) => game.group_alias === filters.groupAlias);
    }

    // Create game objects array
    const gameImages = games.map((game) => {
      let imagePath = game.iconUrl;

      return {
        id: game.id,
        alias: game.alias,
        imagePath: imagePath,
        provider: game.provider,
        name: game.title || formatGameName(game.alias),
        groupAlias: game.group_alias,
        isEnabled: game.is_enabled,
        isFreeroundsEnabled: game.is_freerounds_enabled,
        desktopEnabled: game.desktop_enabled,
        mobileEnabled: game.mobile_enabled,
        meta: game.meta,
        tags: game.tags || [],
        // Add original API data for reference
        apiData: game,
      };
    });
    return gameImages;
  } catch (error) {
    console.error(`Error importing Kelt game images:`, error);

    // Fallback to old method if API fails
    // console.log("Falling back to local image scanning...");
  }
};
// Convert topGamesData to array format as well
export const topGamesArray = [
  {
    alias: "aviator",
    imagePath: aviatorImg,
    provider: "aviator",
    name: "Aviator",
  },
  {
    alias: "aviatrix",
    imagePath: aviatrixImg,
    provider: "aviatrix",
    name: "Aviatrix",
  },
  {
    alias: "JetX",
    imagePath: jetXimg,
    provider: "smartsoft",
    name: "JetX",
  },
  {
    alias: "mines",
    imagePath: minesImg,
    provider: "spribe",
    name: "Mines",
  },
  {
    alias: "keno",
    imagePath: kenoImg,
    provider: "spribe",
    name: "Keno",
  },
  {
    alias: "rocketmen",
    imagePath: rocketmenImg,
    provider: "redtiger",
    name: "Rocketmen",
  },
  {
    alias: "dice",
    imagePath: diceImg,
    provider: "spribe",
    name: "Dice",
  },
];

/**
 * Dynamically imports game images based on provider and dimensions
 * @param {string} provider - Provider folder name (e.g., 'netent', 'pragmatic', 'kelt')
 * @param {string} dimension - Dimension folder name (e.g., '225-140')
 * @returns {Promise<Array>} Array of game objects with alias, imagePath, and other properties
 */
export const importGameImages = async (provider, dimension = "167-117") => {
  try {
    // Special handling for ABX provider that uses API data with image folder
    if (provider === "abx") {
      return await importAbxGameImages(dimension);
    }
    // Special handling for Tada provider that uses API data with image folder
    if (provider === "tada") {
      return await importTadaGameImages(dimension);
    }
    // Special handling for Kelt provider that has multiple sub-providers
    if (isKeltProvider(provider)) {
      return await importKeltGameImages(dimension, provider);
    }
    // Special handling for Pragmatic provider that uses API data
    if (provider === "pragmaticplay") {
      return await importPragmaticGameImages(dimension);
    }
    // Special handling for velitest provider that uses API data
    if (provider === "velitest") {
      return await importVeliTest(dimension);
    }
    // Special handling for Expanse provider that uses API data with image folder
    if (provider === "expanse") {
      return await importExpanseGameImages(dimension);
    }
    // Special handling for smartsoft provider that uses API data with image folder
    if (provider === "smartsoft") {
      return await importSmartsoftGameImages(dimension);
    }
    // Special handling for veligames provider that uses API data with image folder
    if (provider === "veligames") {
      return await importVeligamesGameImages(dimension);
    }
    // Special handling for Leprecoins provider that uses API data with image folder
    if (provider === "leprecoins") {
      return await importLeprecoinsGameImages(dimension);
    }
    // Standard handling for other providers
    // Using webpack's require.context to get all images in the specified provider/dimension folder
    const context = require.context(
      "../images/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );

    // Get all matching file paths
    const gamePaths = context
      .keys()
      .filter((path) => path.includes(`/${provider}/`));

    // Create an array of game objects
    const gameImages = [];

    gamePaths.forEach((path) => {
      // Extract game alias from the file path
      // Example path: ./netent/225-140/starburst.png -> starburst
      const alias = path
        .split("/")
        .pop()
        .replace(/\.[^/.]+$/, "");

      gameImages.push({
        alias: alias,
        imagePath: context(path),
        provider: provider,
        name: formatGameName(alias), // Create readable name from alias
      });
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing game images for ${provider}:`, error);
    return [];
  }
};

/**
 * Loads all game images from all providers
 * @returns {Promise<Array>} Array of all game objects
 */
// export const loadAllGameImages = async () => {
//   try {
//     // Get all available providers
//     const providers = await getAvailableProviders();
//     const allGames = [];

//     // Load games for each provider
//     for (const provider of providers) {
//       // Special handling for Pragmatic provider
//       if (provider === "pragmatic") {
//         const pragmaticGames = await importGameImages(
//           "pragmaticplay",
//           "225-140"
//         );
//         allGames.push(...pragmaticGames);
//       } else {
//         // Standard handling for other providers
//         const games = await importGameImages(provider);
//         allGames.push(...games);
//       }
//     }

//     console.log("Total games loaded:", allGames.length);
//     return allGames;
//   } catch (error) {
//     console.error("Error loading all game images:", error);
//     return [];
//   }
// };

// Helper function for sorting games
export const sortGamesByName = (games, ascending = true) => {
  return [...games].sort((a, b) => {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();

    if (ascending) {
      return nameA.localeCompare(nameB);
    } else {
      return nameB.localeCompare(nameA);
    }
  });
};

// Helper function for filtering games by provider
export const filterGamesByProvider = (games, provider) => {
  return games.filter((game) => game.provider === provider);
};

// Helper function for searching games
export const searchGames = (games, searchTerm) => {
  const term = searchTerm.toLowerCase();
  return games.filter(
    (game) =>
      game.name.toLowerCase().includes(term) ||
      game.alias.toLowerCase().includes(term) ||
      game.provider.toLowerCase().includes(term)
  );
};
/**
 * Fetches game data from Pragmatic Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchPragmaticGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(
      `${APP_CONFIG.API_URL}/api/pragmaticgameiconurls`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Pragmatic games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Pragmatic Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchLeprecoinsGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}/api/leprecoins/games`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching leprecoins games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Pragmatic Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchAbxGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}/abx-games`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching abx games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Expanse Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchExpanseGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}api/expanse/games`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching expance games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Expanse Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchSmartsoftGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}smartsoft/getgames`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching sa games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Tada Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchTadaGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}tada/getgamelist`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Pragmatic games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Pragmatic Provider API
 * @returns {Promise<Object>} The API response with Live game list
 */
export const fetchLivePragmaticGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}/livecasino/thumbnails`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Live Pragmatic games:", error);
    throw error;
  }
};

/**
 * Fetches game data from Kelt Provider API
 * @param {string} subProvider - Sub-provider name (e.g., 'igrosoft', 'playtech', etc.)
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchKeltGames = async (subProvider = null) => {
  try {
    // Build API URL with optional sub-provider filter
    let apiUrl = `${APP_CONFIG.API_URL}api/mobuleapi/gamelist`;
    if (subProvider) {
      apiUrl += `?provider=${subProvider}`;
    }

    const response = await fetch(apiUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Kelt games:", error);
    throw error;
  }
};
export const fetchVeliGames = async (providerId = "veliplay") => {
  try {
    // Build API URL with optional sub-provider filter
    let apiUrl = `${APP_CONFIG.API_URL}veligames/getgames`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        providerId,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Kelt games:", error);
    throw error;
  }
};
/**
 * Gets available providers from the games directory
 * @returns {Promise<string[]>} Array of provider names
 */
// export const getAvailableProviders = async () => {
//   try {
//     const context = require.context(
//       "../images/icons_mobule_new",
//       true,
//       /\.(png|jpe?g|svg)$/
//     );

//     // Extract unique provider names from paths
//     const providers = new Set(
//       context
//         .keys()
//         .map((path) => path.split("/")[1])
//         .filter(Boolean)
//     );

//     return Array.from(providers);
//   } catch (error) {
//     console.error("Error getting available providers:", error);
//     return [];
//   }
// };

/**
 * Gets available dimensions for a specific provider
 * @param {string} provider - Provider name
 * @returns {Promise<string[]>} Array of dimension options
 */
// export const getAvailableDimensions = async (provider) => {
//   try {
//     const context = require.context(
//       "../images/icons_mobule_new",
//       true,
//       /\.(png|jpe?g|svg)$/
//     );

//     // Extract unique dimensions from paths for the specified provider
//     const dimensions = new Set(
//       context
//         .keys()
//         .filter((path) => path.includes(`/${provider}/`))
//         .map((path) => path.split("/")[2])
//         .filter(Boolean)
//     );

//     return Array.from(dimensions);
//   } catch (error) {
//     console.error(`Error getting dimensions for ${provider}:`, error);
//     return [];
//   }
// };
// Function to detect if user is on mobile
export const isMobileDevice = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
export const getPlatformType = () => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/.test(userAgent)) return "Android";
  if (/iphone|ipad|ipod/.test(userAgent)) return "iOS";
  if (/win/.test(platform)) return "Windows";
  if (/mac/.test(platform)) return "MacOS";
  if (/linux/.test(platform)) return "Linux";
  return "Unknown";
};
export const generateGameUrl = (params) => {
  const isDemo = params.mode === GameModes.DEMO;
  const endpoint = isDemo ? "games.startDemo" : "games.start";

  const queryParams = new URLSearchParams({
    "partner.alias": params.partnerAlias || config.partnerAlias,
    "game.provider": params.provider,
    "game.alias": params.gameAlias,
    "partner.session": "params.sessionId",
    currency: params.currency || config.defaultCurrency,
    mobile: isMobileDevice(),
    lang: params.lang || config.defaultLang,
  });

  return `${config.mobuleBaseUrl}/${endpoint}?${queryParams.toString()}`;
};

// Transform API data to match the React component structure
export const transformApiDataOld = (apiData) => {
  // Handle case when apiData is an array or a single object
  const apiDataArray = Array.isArray(apiData) ? apiData : [apiData];

  return apiDataArray.map((leagueData) => {
    return {
      leagueTitle: leagueData.leagueName,
      titleWrps: [
        {
          matches: leagueData.events.map((event) => {
            // Parse event details
            const eventDetails = [
              { text: event.eventDate, bold: true },
              {
                text: `#${generateEventId(event.gameName || "")}`,
                bold: false,
              },
              {
                text: `+${getAdditionalMarketsCount(
                  event.additionalMarkets
                )} more`,
                bold: false,
              },
            ];

            // Transform odds structure
            const transformedOdds = transformEventOddsOld(event);

            return {
              team1: getTeam1(event.gameName),
              team2: getTeam2(event.gameName),
              details: eventDetails,
              odds: transformedOdds,
              eventDate: event.eventDate,
              gameId: event.gameId,
            };
          }),
        },
      ],
    };
  });
};

// Helper function to extract team1 from event name (e.g., "Ukraine V Belgium" -> "Ukraine")
const getTeam1 = (gameName) => {
  return gameName.split(" v ")[0];
};

// Helper function to extract team2 from event name (e.g., "Ukraine V Belgium" -> "Belgium")
const getTeam2 = (gameName) => {
  return gameName.split(" v ")[1];
};

// Helper function to generate a pseudo event ID from game name
// In real implementation, you might want to use a more reliable ID from your API
const generateEventId = (gameName) => {
  return Math.abs(
    gameName.split("").reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0)
  )
    .toString()
    .substring(0, 4);
};

// Helper function to count additional markets
const getAdditionalMarketsCountOld = (markets) => {
  return markets ? markets.length : 0;
};
// Updated main transform function
// Updated transform function to ensure proper data structure
export const transformApiData = (apiData) => {
  const apiDataArray = Array.isArray(apiData) ? apiData : [apiData];
  const leagueMap = new Map();

  apiDataArray.forEach((leagueData) => {
    const leagueTitle = leagueData.leagueName;
    const leagueId = leagueData.leagueId;
    const country =
      leagueData.country || extractCountryFromLeagueName(leagueData.leagueName);

    // Transform the matches with enhanced date handling
    const matches = leagueData.events.map((event) => {
      const eventDetails = [
        {
          text:
            formatEventDate(event.eventDate) ||
            formatEventTime(event.eventDate) ||
            "TBD",
          bold: true,
        },
        {
          text: `#${event.gameId || generateEventId(event.gameName)}`,
          bold: false,
        },
        {
          text: `+${getAdditionalMarketsCount(event.odds)}`,
          bold: false,
        },
      ];

      const { odds, marketStatuses } = transformEventOddsNew(event);

      return {
        team1: getTeam1(event.gameName),
        team2: getTeam2(event.gameName),
        details: eventDetails,
        odds,
        marketStatuses,
        eventDate: event.eventDate || null,
        gameId: event.gameId || leagueData.gameId,
        gameName: event.gameName,
      };
    });

    // If league already exists, append matches
    if (leagueMap.has(leagueTitle)) {
      leagueMap.get(leagueTitle).titleWrps[0].matches.push(...matches);
    } else {
      leagueMap.set(leagueTitle, {
        leagueTitle,
        leagueId,
        country,
        titleWrps: [{ matches }],
      });
    }
  });

  return Array.from(leagueMap.values());
};
// Helper function to extract country from league name
const extractCountryFromLeagueName = (leagueName) => {
  if (!leagueName) return "";

  // Common patterns for extracting country
  const countryPatterns = [
    /^([A-Za-z\s]+?)\s+(?:Liga|League|Championship|Cup|Premier|Division)/i,
    /^([A-Za-z\s]+?)\s+-/,
    /^([A-Za-z\s]+?)\s+[A-Z]/,
  ];

  for (const pattern of countryPatterns) {
    const match = leagueName.match(pattern);
    if (match && match[1]) {
      return match[1].trim();
    }
  }

  // Fallback: take first word
  return leagueName.split(" ")[0] || "";
};
// Helper function to check if two dates are the same day
const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

// Enhanced date formatting
const formatEventDate = (eventDate) => {
  if (!eventDate) return null;

  try {
    const date = new Date(eventDate);
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

    if (isSameDay(date, today)) {
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    } else if (isSameDay(date, tomorrow)) {
      return `Tomorrow ${date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })}`;
    } else {
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    }
  } catch (error) {
    console.error("Error formatting date:", error);
    return null;
  }
};

const formatEventTime = (eventDate) => {
  if (!eventDate) return null;

  try {
    const date = new Date(eventDate);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch (error) {
    return null;
  }
};

// Utility function to standardize betting labels
const standardizeBettingLabels = (odds, marketName, team1, team2) => {
  if (!odds || !Array.isArray(odds)) return odds;

  return odds.map((odd) => {
    const newOdd = { ...odd };
    // console.log("check😂😂😁", odd, odd.label === team1, odd.label, team1);
    switch (marketName) {
      case "Match Result":
      case "1X2":
        // Convert team names to 1, X, 2
        if (odd.label === team1) {
          newOdd.label = "1";
        } else if (odd.label === team2) {
          newOdd.label = "2";
        } else if (odd.label.toLowerCase() === "draw") {
          newOdd.label = "X";
        }
        break;

      case "Double Chance":
        const label = odd.label.toLowerCase();
        const team1Lower = team1.toLowerCase();
        const team2Lower = team2.toLowerCase();

        if (
          (label.includes(team1Lower) && label.includes("draw")) ||
          (label.includes("draw") && label.includes(team1Lower))
        ) {
          newOdd.label = "1X";
        } else if (
          (label.includes(team1Lower) && label.includes(team2Lower)) ||
          (label.includes(team2Lower) && label.includes(team1Lower))
        ) {
          newOdd.label = "12";
        } else if (
          (label.includes("draw") && label.includes(team2Lower)) ||
          (label.includes(team2Lower) && label.includes("draw"))
        ) {
          newOdd.label = "X2";
        } else if (label === "1x" || label === "x1") {
          newOdd.label = "1X";
        } else if (label === "12" || label === "21") {
          newOdd.label = "12";
        } else if (label === "x2" || label === "2x") {
          newOdd.label = "X2";
        }
        break;

      case "Both Teams To Score":
      case "Both Teams to Score":
        // Standardize to Yes/No
        const bttsLabel = odd.label.toLowerCase();
        if (bttsLabel.includes("yes") || bttsLabel === "both teams to score") {
          newOdd.label = "Yes";
        } else if (bttsLabel.includes("no") || bttsLabel === "no btts") {
          newOdd.label = "No";
        }
        break;

      case "Over/Under 2.5 Goals":
      case "Total Goals":
        // Standardize Over/Under labels
        const ouLabel = odd.label.toLowerCase();
        if (ouLabel.includes("over") && ouLabel.includes("2.5")) {
          newOdd.label = "Over 2.5";
        } else if (ouLabel.includes("under") && ouLabel.includes("2.5")) {
          newOdd.label = "Under 2.5";
        }
        break;

      case "Handicap":
      case "Asian Handicap":
        // Keep handicap labels as they usually come formatted correctly
        // But ensure consistent format like (+1), (-1), etc.
        if (odd.label.includes(team1)) {
          // Extract handicap value and apply to "1"
          const handicapMatch = odd.label.match(/([+-]?\d+\.?\d*)/);
          if (handicapMatch) {
            newOdd.label = `1 (${handicapMatch[1]})`;
          }
        } else if (odd.label.includes(team2)) {
          // Extract handicap value and apply to "2"
          const handicapMatch = odd.label.match(/([+-]?\d+\.?\d*)/);
          if (handicapMatch) {
            newOdd.label = `2 (${handicapMatch[1]})`;
          }
        }
        break;

      default:
        // For other markets, keep original label but clean it up
        break;
    }
    // console.log("TR😂😂😂😁", newOdd);
    return newOdd;
  });
};

// Updated function to handle the new odds format with label standardization
const transformEventOddsNew = (event) => {
  const odds = [];
  const marketStatuses = {}; // New: Store trading statuses for each market
  const team1 = getTeam1(event.gameName);
  const team2 = getTeam2(event.gameName);

  // Helper function to extract trading status from market
  const extractTradingStatus = (marketData, marketName) => {
    const statusItem = marketData.find(
      (item) => item.label === "TradingStatus"
    );
    const status = statusItem ? statusItem.value : "Open"; // Default to "Open" if not found
    marketStatuses[marketName] = status;
    return status;
  };

  // Helper function to process market odds with status tracking
  const processMarket = (marketName, colSpan = 4) => {
    if (event.odds[marketName]) {
      // Extract trading status first
      const tradingStatus = extractTradingStatus(
        event.odds[marketName],
        marketName
      );

      // Filter out TradingStatus and process odds
      const marketOdds = event.odds[marketName]
        .filter((item) => item.label !== "TradingStatus")
        .map((odd) => ({
          label: odd.label,
          value: odd.value === "null" ? null : odd.value,
          colSpan: colSpan,
          selectionId: odd.selectionId,
          highlight: false,
          tradingStatus: tradingStatus, // Add trading status to each odd
          marketName: marketName, // Add market name for reference
        }));

      // Standardize the labels
      const standardizedOdds = standardizeBettingLabels(
        marketOdds,
        marketName,
        team1,
        team2
      );

      // Add market-level metadata to the standardized odds
      if (standardizedOdds.length > 0) {
        // Add market metadata to the row
        const oddsWithMetadata = {
          marketName: marketName,
          tradingStatus: tradingStatus,
          odds: standardizedOdds,
          // Maintain backward compatibility by spreading the odds array
          ...standardizedOdds,
        };

        odds.push(standardizedOdds); // Keep original format for backward compatibility
      }
    }
  };

  // Check if odds exist and handle the new structure
  if (event.odds) {
    // First row: 1-X-2 (Match Result)
    processMarket("Match Result", 4);

    // Second row: Double Chance (1X-12-X2)
    processMarket("Double Chance", 4);

    // Third row: Both Teams to Score (Yes-No)
    processMarket("Both Teams To Score", 6);

    // Add support for other common markets
    // const otherMarkets = [
    //   "Over/Under 2.5 Goals",
    //   "Total Goals",
    //   "Handicap",
    //   "Asian Handicap",
    //   "Match Result and Total Goals Over/Under +3.5",
    //   "Second Half Double Chance",
    //   "Away Team Total Goals Over/Under +1.25",
    // ];
    const otherMarkets = [
      "Over/Under 2.5 Goals",
      "Total Goals",
      "Handicap",
      // "Second Half Double Chance",
      "Asian Handicap",
      "Over/Under +2.5",
    ];
    otherMarkets.forEach((marketName) => {
      const colSpan =
        marketName.includes("Over/Under") ||
        marketName.includes("Total") ||
        marketName.includes("Both Teams")
          ? 6
          : 4;
      processMarket(marketName, colSpan);
    });
  }

  // Return enhanced structure with market statuses
  return {
    odds: odds, // Original odds array for backward compatibility
    marketStatuses: marketStatuses, // New: Trading statuses by market
    // For complete backward compatibility, spread the odds array
    ...odds,
  };
};

// Alternative version if you want to keep the exact same return format
// but add trading status information to each odd item
const transformEventOddsNewWithStatus = (event) => {
  const odds = [];
  const team1 = getTeam1(event.gameName);
  const team2 = getTeam2(event.gameName);

  // Helper function to extract trading status
  const getTradingStatus = (marketData) => {
    const statusItem = marketData.find(
      (item) => item.label === "TradingStatus"
    );
    return statusItem ? statusItem.value : "Open";
  };

  // Check if odds exist and handle the new structure
  if (event.odds) {
    // First row: 1-X-2 (Match Result)
    if (event.odds["Match Result"]) {
      const tradingStatus = getTradingStatus(event.odds["Match Result"]);

      const matchResultOdds = event.odds["Match Result"]
        .filter((item) => item.label !== "TradingStatus")
        .map((odd) => ({
          label: odd.label,
          value: odd.value === "null" ? null : odd.value,
          colSpan: 4,
          highlight: false,
          tradingStatus: tradingStatus, // Add status to each odd
          marketName: "Match Result",
        }));

      // Standardize the labels
      const standardizedMatchResult = standardizeBettingLabels(
        matchResultOdds,
        "Match Result",
        team1,
        team2
      );

      if (standardizedMatchResult.length > 0) {
        odds.push(standardizedMatchResult);
      }
    }

    // Second row: Double Chance (1X-12-X2)
    if (event.odds["Double Chance"]) {
      const tradingStatus = getTradingStatus(event.odds["Double Chance"]);

      const doubleChanceOdds = event.odds["Double Chance"]
        .filter((item) => item.label !== "TradingStatus")
        .map((odd) => ({
          label: odd.label,
          value: odd.value === "null" ? null : odd.value,
          colSpan: 4,
          highlight: false,
          tradingStatus: tradingStatus,
          marketName: "Double Chance",
        }));

      // Standardize the labels
      const standardizedDoubleChance = standardizeBettingLabels(
        doubleChanceOdds,
        "Double Chance",
        team1,
        team2
      );

      if (standardizedDoubleChance.length > 0) {
        odds.push(standardizedDoubleChance);
      }
    }

    // Third row: Both Teams to Score (Yes-No)
    if (event.odds["Both Teams To Score"]) {
      const tradingStatus = getTradingStatus(event.odds["Both Teams To Score"]);

      const bothTeamsOdds = event.odds["Both Teams To Score"]
        .filter((item) => item.label !== "TradingStatus")
        .map((odd) => ({
          label: odd.label,
          value: odd.value === "null" ? null : odd.value,
          colSpan: 6,
          highlight: false,
          tradingStatus: tradingStatus,
          marketName: "Both Teams To Score",
        }));

      // Standardize the labels
      const standardizedBothTeams = standardizeBettingLabels(
        bothTeamsOdds,
        "Both Teams To Score",
        team1,
        team2
      );

      if (standardizedBothTeams.length > 0) {
        odds.push(standardizedBothTeams);
      }
    }

    // Add support for other common markets including your specific ones
    const otherMarkets = [
      "Over/Under 2.5 Goals",
      "Total Goals",
      "Handicap",
      "Asian Handicap",
      "Match Result and Total Goals Over/Under +3.5",
      "Second Half Double Chance",
      "Away Team Total Goals Over/Under +1.25",
    ];

    otherMarkets.forEach((marketName) => {
      if (event.odds[marketName]) {
        const tradingStatus = getTradingStatus(event.odds[marketName]);

        const marketOdds = event.odds[marketName]
          .filter((item) => item.label !== "TradingStatus")
          .map((odd) => ({
            label: odd.label,
            value: odd.value === "null" ? null : odd.value,
            colSpan:
              marketName.includes("Over/Under") || marketName.includes("Total")
                ? 6
                : 4,
            highlight: false,
            tradingStatus: tradingStatus,
            marketName: marketName,
          }));

        const standardizedMarketOdds = standardizeBettingLabels(
          marketOdds,
          marketName,
          team1,
          team2
        );

        if (standardizedMarketOdds.length > 0) {
          odds.push(standardizedMarketOdds);
        }
      }
    });
  }

  return odds; // Same format as before, but with tradingStatus added to each odd
};

// Helper function to count additional markets
const getAdditionalMarketsCount = (odds) => {
  if (!odds) return 0;
  // Count the number of market types excluding the main three if they exist
  const mainMarkets = ["Match Result", "Double Chance", "Both Teams To Score"];
  const totalMarkets = Object.keys(odds).length;
  const mainMarketsPresent = mainMarkets.filter(
    (market) => market in odds
  ).length;

  return Math.max(0, totalMarkets - mainMarketsPresent);
};
const transformEventOddsOld = (event) => {
  const odds = [];

  // First row: 1-X-2 (Match Result)
  const matchResult = findMarket(event.additionalMarkets, "Match Result");
  if (matchResult) {
    odds.push(
      matchResult.marketOdds.map((odd) => ({
        label: odd.label,
        value: odd.value,
        selectionId: odd.selectionId,
        colSpan: 4,
        highlight: false,
      }))
    );
  } else if (event.odds) {
    // Fallback to main odds if Match Result not in additional markets
    odds.push(
      event.odds.map((odd) => ({
        label: odd.label,
        value: odd.value,
        colSpan: 4,
        highlight: false,
      }))
    );
  }

  // Second row: Double Chance (1X-12-X2)
  const doubleChance = findMarket(event.additionalMarkets, "Double Chance");
  if (doubleChance) {
    odds.push(
      doubleChance.marketOdds.map((odd) => ({
        label: odd.label.toLowerCase(),
        value: odd.value,
        colSpan: 4,
        highlight: false,
      }))
    );
  }

  // Third row: Both Teams to Score (yes-no)
  const bothTeams = findMarket(event.additionalMarkets, "Both Teams to Score");
  if (bothTeams) {
    odds.push(
      bothTeams.marketOdds.map((odd) => ({
        label: odd.label.toLowerCase(),
        value: odd.value,
        colSpan: 6,
        highlight: false,
      }))
    );
  }

  return odds;
};

// Helper function to find a specific market by name
const findMarket = (markets, marketName) => {
  if (!markets) return null;
  return markets.find((market) => market.marketName === marketName);
};
// // Existing helper functions (implementation assumed)
// const generateEventId = (gameName) => {
//   // Existing implementation
//   return gameName.replace(/\s/g, '').substring(0, 8);
// };

// const getTeam1 = (gameName) => {
//   // Extract first team from "Team1 v Team2" format
//   return gameName.split(' v ')[0];
// };

// const getTeam2 = (gameName) => {
//   // Extract second team from "Team1 v Team2" format
//   return gameName.split(' v ')[1];
// };

// Transform event odds to match the required structure

export const formatAmount = (amount, currency = "USD", locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
export const detectMobileCarrier = (phoneNumber) => {
  // Remove the country code if present (assumes +254 or 254)
  const cleanedNumber = phoneNumber.replace(/^(\+?254)/, "");

  // Define prefix patterns
  const safaricomPrefixes = /^(?:70|71|72|74|75|76|79)\d{7}$/;
  const airtelPrefixes = /^(?:73|78|10[0-9])\d{7}$/;

  if (safaricomPrefixes.test(cleanedNumber)) {
    return "Safaricom";
  } else if (airtelPrefixes.test(cleanedNumber)) {
    return "Airtel";
  } else {
    return "Unknown";
  }
};
/**
 * Detects Kenyan mobile network provider
 * @param {string} phoneNumber - Phone number in format 2547XXXXXXXX or 07XXXXXXXX
 * @returns {string} - 'Safaricom', 'Airtel', 'Telkom', 'Equitel', 'Faiba', or 'Unknown'
 */
export function detectNetworkProvider(phoneNumber) {
  const cleaned = phoneNumber.toString().replace(/\D/g, "");
  const normalized = cleaned.startsWith("0")
    ? "254" + cleaned.substring(1)
    : cleaned;

  if (!normalized.startsWith("254") || normalized.length < 12) {
    return "Unknown";
  }

  const prefix3 = normalized.substring(3, 6); // 7xx or 1xx
  const prefix4 = normalized.substring(3, 7); // 7xxx or 1xxx

  const safaricomPrefixes = [
    // 070x, 071x, 072x, 074x, 0757-0759, 0768-0769, 079x
    ...range("700", "709"),
    ...range("710", "719"),
    ...range("720", "729"),
    ...range("740", "749"),
    "757",
    "758",
    "759",
    "768",
    "769",
    ...range("790", "799"),
  ];

  const airtelPrefixes = [
    // 0730–0739, 0750–0756, 0785–0789
    ...range("730", "739"),
    ...range("750", "756"),
    ...range("785", "789"),
  ];

  const telkomPrefixes = range("770", "779");
  const equitelPrefixes = range("763", "766");
  const faibaPrefixes = ["747"];
  const airtelNewPrefixes = ["100", "101", "102"];

  if (safaricomPrefixes.includes(prefix3)) {
    return "Safaricom";
  } else if (
    airtelPrefixes.includes(prefix3) ||
    airtelNewPrefixes.includes(prefix3)
  ) {
    return "Airtel";
  } else if (telkomPrefixes.includes(prefix3)) {
    return "Telkom";
  } else if (equitelPrefixes.includes(prefix3)) {
    return "Equitel";
  } else if (faibaPrefixes.includes(prefix3)) {
    return "Faiba";
  } else {
    return "Unknown";
  }
}

// Helper to generate array range (inclusive)
function range(start, end) {
  const result = [];
  let s = parseInt(start, 10);
  let e = parseInt(end, 10);
  while (s <= e) {
    result.push(s.toString().padStart(3, "0"));
    s++;
  }
  return result;
}
export function formatGameName(name) {
  if (!name) return "";

  // Split camelCase by inserting space before capital letters (e.g. superMarioBros -> super Mario Bros)
  const spaced = name.replace(/([a-z])([A-Z])/g, "$1 $2");

  // Convert to lowercase, then split into words
  return spaced
    .toLowerCase()
    .split(/[\s_]+/) // Split by space or underscore
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
export const allowsDemo = (provider) => {
  return !PROVIDERS_WITHOUT_DEMO.includes(provider?.toLowerCase());
};
// Helper function to format date
export function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getFullYear()} ${date
    .getHours()
    .toString()
    .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
}

//   // Example usage:
//   console.log(formatAmount(1234.5)); // $1,234.50 (Default: USD, en-US)
//   console.log(formatAmount(1234.5, "EUR", "de-DE")); // 1.234,50 € (Euro, German locale)
//   console.log(formatAmount(1234.5, "KES", "sw-KE")); // KSh1,234.50 (Kenyan Shilling)
